import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import IntroOverlay from "@/components/IntroOverlay";
import Home from "@/pages/Home";
import Music from "@/pages/Music";
import Merch from "@/pages/Merch";
import About from "@/pages/About";
import Fire from "@/pages/Fire";
import Media from "@/pages/Media";
import Den from "@/pages/Den";
import WolfDawg from "@/pages/WolfDawg";
import Login from "@/pages/Login";
import Register from "@/pages/Register";

function Shell() {
  const loc = useLocation();
  const isAuthPage = ["/login", "/register"].includes(loc.pathname);
  return (
    <div className="App grain min-h-screen">
      <IntroOverlay />
      <ScrollToTop />
      {!isAuthPage && <Nav />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/music" element={<Music />} />
        <Route path="/merch" element={<Merch />} />
        <Route path="/about" element={<About />} />
        <Route path="/fire" element={<Fire />} />
        <Route path="/media" element={<Media />} />
        <Route path="/wolf-dawg" element={<WolfDawg />} />
        <Route
          path="/den"
          element={
            <ProtectedRoute>
              <Den />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>
      {!isAuthPage && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}
